module.exports = "/_next/static/images/f38458d11cb28422b18dcbb9ed93bbc6-roxinho-card-with-phone-xs@2x.png.webp";